module.exports = __webpack_public_path__ + "img/springboot.fb4afcd7.png";